import {DynamicProductionTimeRequest} from '../services/api/dynamic-production-time'

import {QuantityThresholdItem} from '../types'

const getApplicableQuantityThreshold = (
  dynamicProductionTimeRequest: Partial<DynamicProductionTimeRequest>,
  maxDimension: number
): QuantityThresholdItem | undefined => {
  if (
    !dynamicProductionTimeRequest.quantityThresholds ||
    dynamicProductionTimeRequest.quantityThresholds.length === 0 ||
    dynamicProductionTimeRequest.quantityThresholds[0].qtyThreshold === null
  ) {
    return undefined
  }

  let item = dynamicProductionTimeRequest.quantityThresholds[0]
  for (let i = 0; i < dynamicProductionTimeRequest.quantityThresholds.length; i += 1) {
    if (
      maxDimension < dynamicProductionTimeRequest.quantityThresholds[i].axisSize ||
      dynamicProductionTimeRequest.quantityThresholds[i].axisSize === null ||
      dynamicProductionTimeRequest.quantityThresholds[i].qtyThreshold === null
    ) {
      break
    }
    item = dynamicProductionTimeRequest.quantityThresholds[i]
  }

  return item
}

export const calculateProductionTimes = (
  dynamicProductionTimeRequest: Partial<DynamicProductionTimeRequest>,
  {
    largestAxisSize = 0,
    defaultProductionTimeMin = 0,
    defaultProductionTimeMax = 0,
    quantity = 1,
  }: {
    largestAxisSize?: number
    defaultProductionTimeMin?: number
    defaultProductionTimeMax?: number
    quantity?: number
  }
) => {
  // Find the applicable qytThreshold via the biggest dimension (-> axisSize)
  const applicableThresholdItem = getApplicableQuantityThreshold(
    dynamicProductionTimeRequest,
    largestAxisSize
  )

  let increaseStepsMultiplier = 0
  let calculatedStepsOnTop = 0

  if (applicableThresholdItem) {
    // Divide the given quantity by the applicable qytThreshold
    const increseStepsMultiplierTemp = Math.trunc(quantity / applicableThresholdItem.qtyThreshold)
    increaseStepsMultiplier = increseStepsMultiplierTemp >= 1 ? increseStepsMultiplierTemp : 0
    // And multiply it with the increaseSteps
    calculatedStepsOnTop =
      (dynamicProductionTimeRequest.increaseSteps || 0) * increaseStepsMultiplier
  }

  // Consider maxIncrease
  const resultStepsOnTop = Math.min(
    calculatedStepsOnTop,
    dynamicProductionTimeRequest.maxIncrease || 0
  )

  // Add the result on top of the defaultProductionTimeMin and defaultProductionTimeMax
  const resultProductionTimeMin = defaultProductionTimeMin + resultStepsOnTop
  const resultProductionTimeMax = defaultProductionTimeMax + resultStepsOnTop

  return {
    resultStepsOnTop,
    resultProductionTimeMin,
    resultProductionTimeMax,
  }
}
